export default __webpack_public_path__ + "static/media/logo-color.bbb09c0f.png";